/* ── Mobile Menu ───────────────────────────────── */
function initMobileMenu() {
  var menuOpen = document.getElementById('menuOpen');
  var menuClose = document.getElementById('menuClose');
  var menuOverlay = document.getElementById('menuOverlay');
  var menuPanel = document.getElementById('menuPanel');
  if (!menuOpen) return;

  function openMenu() {
    menuOverlay.classList.add('open');
    menuPanel.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menuOverlay.classList.remove('open');
    menuPanel.classList.remove('open');
    document.body.style.overflow = '';
  }
  menuOpen.addEventListener('click', openMenu);
  menuClose.addEventListener('click', closeMenu);
  menuOverlay.addEventListener('click', closeMenu);

  // Collapsible mobile nav groups
  var toggles = menuPanel.querySelectorAll('.mobile-nav-toggle');
  toggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.mobile-nav-group');
      var isOpen = group.classList.contains('open');
      // Close all others first
      menuPanel.querySelectorAll('.mobile-nav-group.open').forEach(function(g) {
        if (g !== group) g.classList.remove('open');
      });
      group.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}

/* ── Mobile Search Overlay ─────────────────────── */
function initMobileSearch() {
  var toggle = document.getElementById('mobileSearchToggle');
  var overlay = document.getElementById('mobileSearchOverlay');
  var closeBtn = document.getElementById('mobileSearchClose');
  var input = document.getElementById('mobileSearchInput');
  var resultsEl = document.getElementById('mobileSearchResults');
  if (!toggle || !overlay) return;

  function open() {
    overlay.classList.add('open');
    document.body.classList.add('mobile-search-open');
    setTimeout(function() { input && input.focus(); }, 80);
  }
  function close() {
    overlay.classList.remove('open');
    document.body.classList.remove('mobile-search-open');
  }
  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Predictive search via Shopify's predictive_search.json
  var debounceTimer = null;
  function fetchResults(q) {
    if (!q || q.length < 2) {
      resultsEl.innerHTML = '<div class="mobile-search-results__hint">Skriv minst 2 tecken…</div>';
      return;
    }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10';
    fetch(url)
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          resultsEl.innerHTML = '<div class="mobile-search-results__hint">Inga träffar för "' + escapeHtml(q) + '"</div>';
          return;
        }
        resultsEl.innerHTML = products.map(function(p){
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var imgHtml = img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '">' : '';
          return '<a class="search-result-row" href="' + p.url + '">' +
            '<div class="search-result-row__img">' + imgHtml + '</div>' +
            '<div class="search-result-row__info">' +
              '<div class="search-result-row__title">' + escapeHtml(p.title) + '</div>' +
              '<div class="search-result-row__price">' + (p.price || '') + '</div>' +
            '</div></a>';
        }).join('');
      })
      .catch(function(){
        resultsEl.innerHTML = '<div class="mobile-search-results__hint">Sökningen misslyckades, försök igen</div>';
      });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]); });
  }
  if (input) {
    input.addEventListener('input', function(){
      clearTimeout(debounceTimer);
      var v = input.value.trim();
      debounceTimer = setTimeout(function(){ fetchResults(v); }, 200);
    });
  }
}

/* ── Carousel Progress Bars ────────────────────── */
function setupCarouselProgress(trackId, thumbId) {
  var track = document.getElementById(trackId);
  var thumb = document.getElementById(thumbId);
  if (!track || !thumb) return;

  function update() {
    var scrollLeft = track.scrollLeft;
    var scrollWidth = track.scrollWidth - track.clientWidth;
    if (scrollWidth <= 0) {
      thumb.style.width = '100%';
      thumb.style.transform = 'translateX(0)';
      return;
    }
    var ratio = track.clientWidth / track.scrollWidth;
    var thumbWidth = Math.max(ratio * 100, 20);
    var position = (scrollLeft / scrollWidth) * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.transform = 'translateX(' + (position / thumbWidth * 100) + '%)';
  }

  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

/* ── Filter Pills (Collection) ─────────────────── */
function initFilterPills() {
  var pills = document.querySelectorAll('.filter-pill');
  var cards = document.querySelectorAll('#productGrid .product-card');
  var countText = document.querySelector('.count-text');
  if (!pills.length) return;

  function filterProducts(category) {
    pills.forEach(function(p) { p.classList.remove('active'); });
    var activePill = document.querySelector('.filter-pill[data-filter="' + category + '"]');
    if (activePill) activePill.classList.add('active');

    var visible = 0;
    cards.forEach(function(card) {
      if (category === 'alla' || (card.dataset.category && card.dataset.category.indexOf(category) !== -1)) {
        card.style.display = '';
        visible++;
      } else {
        card.style.display = 'none';
      }
    });
    if (countText) countText.textContent = 'Visar ' + visible + ' produkt' + (visible !== 1 ? 'er' : '');
  }

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var cat = pill.dataset.filter;
      filterProducts(cat);
      history.replaceState(null, '', '?kategori=' + cat);
    });
  });

  var urlParams = new URLSearchParams(window.location.search);
  var startCat = urlParams.get('kategori');
  if (startCat && document.querySelector('.filter-pill[data-filter="' + startCat + '"]')) {
    filterProducts(startCat);
  }
}

/* ── Product Image Gallery ─────────────────────── */
function initProductGallery() {
  var mainImage = document.getElementById('mainImage');
  if (!mainImage) return;

  var thumbnails = document.querySelectorAll('.thumbnail');
  var imgPrev = document.getElementById('imgPrev');
  var imgNext = document.getElementById('imgNext');
  var images = Array.from(thumbnails).map(function(t) { return t.src; });
  var currentIndex = 0;

  function setImage(index) {
    currentIndex = index;
    mainImage.src = images[index];
    thumbnails.forEach(function(t, i) { t.classList.toggle('active', i === index); });
  }

  thumbnails.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { setImage(i); });
  });
  if (imgPrev) imgPrev.addEventListener('click', function() { setImage((currentIndex - 1 + images.length) % images.length); });
  if (imgNext) imgNext.addEventListener('click', function() { setImage((currentIndex + 1) % images.length); });
}

/* ── Accordion ─────────────────────────────────── */
function initAccordions() {
  var accordionItems = document.querySelectorAll('[data-accordion]');
  accordionItems.forEach(function(item) {
    var header = item.querySelector('.accordion-header');
    var body = item.querySelector('.accordion-body');
    var inner = item.querySelector('.accordion-body-inner');
    if (!header || !body || !inner) return;

    if (item.classList.contains('open')) {
      body.style.maxHeight = inner.scrollHeight + 'px';
    }

    header.addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      if (isOpen) {
        body.style.maxHeight = inner.scrollHeight + 'px';
        body.offsetHeight; // force reflow
        body.style.maxHeight = '0';
        item.classList.remove('open');
      } else {
        item.classList.add('open');
        body.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });
}

/* ── Add to Cart Button ────────────────────────── */
function initAddToCart() {
  var addToCartBtn = document.getElementById('addToCartBtn');
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener('click', function() {
    var originalHTML = addToCartBtn.innerHTML;
    addToCartBtn.innerHTML = '<i class="fas fa-check" style="font-size:14px;"></i> Tillagd i varukorgen';
    addToCartBtn.style.background = '#A59284';
    setTimeout(function() {
      addToCartBtn.innerHTML = originalHTML;
      addToCartBtn.style.background = '';
    }, 2000);
  });
}

/* ── Dropdown Navigation ───────────────────────── */
function initDropdowns() {
  var navItems = document.querySelectorAll('.nav-item.has-dropdown');
  if (!navItems.length) return;

  navItems.forEach(function(item) {
    var link = item.querySelector('.nav-link');

    // Open on click (toggle)
    link.addEventListener('click', function(e) {
      var isOpen = item.classList.contains('open');
      // Close all others
      navItems.forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) {
        e.preventDefault();
        item.classList.add('open');
      }
    });
  });

  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-item')) {
      navItems.forEach(function(i) { i.classList.remove('open'); });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      navItems.forEach(function(i) { i.classList.remove('open'); });
    }
  });
}

/* ── Mobile swipe-gallery (PDP) ─────────────────── */
function initMobileGallerySwipe() {
  if (window.innerWidth > 768) return;
  var galleries = document.querySelectorAll('.product-gallery--grid, .product-gallery--stacked');
  galleries.forEach(function(gallery) {
    var items = gallery.querySelectorAll('.product-gallery__item');
    if (items.length < 2) return;

    // Swipe-hint pil (försvinner vid första scroll)
    var hint = document.createElement('div');
    hint.className = 'gallery-swipe-hint';
    hint.innerHTML = '<i class="fas fa-chevron-right"></i>';
    gallery.appendChild(hint);

    // Dots-indikator under galleriet
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'gallery-dots';
    items.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'gallery-dots__dot' + (i === 0 ? ' is-active' : '');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Visa bild ' + (i + 1));
      dot.addEventListener('click', function() {
        items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });
    gallery.parentNode.insertBefore(dotsWrap, gallery.nextSibling);

    // Sync dots med scrollposition
    var scrollTimeout;
    gallery.addEventListener('scroll', function() {
      if (!hint.classList.contains('is-hidden')) hint.classList.add('is-hidden');
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var center = gallery.scrollLeft + gallery.clientWidth / 2;
        var closest = 0;
        var minDist = Infinity;
        items.forEach(function(item, i) {
          var itemCenter = item.offsetLeft + item.clientWidth / 2;
          var dist = Math.abs(itemCenter - center);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        dotsWrap.querySelectorAll('.gallery-dots__dot').forEach(function(d, i) {
          d.classList.toggle('is-active', i === closest);
        });
      }, 60);
    }, { passive: true });
  });
}

/* ── Init All ──────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initMobileSearch();
  initDropdowns();
  initFilterPills();
  initProductGallery();
  initMobileGallerySwipe();
  initAccordions();
  initAddToCart();

  // Carousels
  ['nyhetTrack', 'popTrack', 'relatedTrack'].forEach(function(id) {
    setupCarouselProgress(id, id.replace('Track', 'Thumb'));
  });

  initCartDrawer();
  initStickyAddToCart();
  initImageZoom();
  initTransparentHeader();
  initRecentlyViewed();
  initUspCarousel();
});

/* ── USP Carousel (mobil) ──────────────────────── */
function initUspCarousel() {
  var bar = document.querySelector('.usp-bar--carousel');
  if (!bar) return;
  var track = bar.querySelector('.usp-track');
  if (!track) return;
  var items = Array.prototype.filter.call(track.children, function(el) {
    return el.classList.contains('usp-item') && !el.classList.contains('usp-hide-mobile');
  });
  if (items.length === 0) return;
  var prev = bar.querySelector('.usp-arrow--prev');
  var next = bar.querySelector('.usp-arrow--next');
  var interval = parseInt(bar.dataset.rotateInterval, 10) || 0;
  var index = 0;
  var timer = null;

  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }

  function show(i) {
    items.forEach(function(el) { el.classList.remove('usp-active'); });
    index = ((i % items.length) + items.length) % items.length;
    items[index].classList.add('usp-active');
  }

  function start() {
    stop();
    if (interval > 0 && isMobile() && items.length > 1) {
      timer = setInterval(function() { show(index + 1); }, interval);
    }
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  function apply() {
    if (isMobile()) {
      show(index);
      start();
    } else {
      stop();
      items.forEach(function(el) { el.classList.remove('usp-active'); });
    }
  }

  if (prev) prev.addEventListener('click', function() { show(index - 1); start(); });
  if (next) next.addEventListener('click', function() { show(index + 1); start(); });

  window.addEventListener('resize', apply);
  apply();
}

/* ── Cart Drawer ───────────────────────────────── */
function initCartDrawer() {
  var trigger = document.querySelector('[data-cart-drawer]');
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartDrawerOverlay');
  var closeBtn = document.getElementById('cartDrawerClose');
  if (!drawer || !overlay) return;

  function openDrawer(e) {
    if (e) e.preventDefault();
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // AJAX cart updates
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;
    var key = btn.dataset.key;
    var line = btn.closest('.cart-drawer__item');
    var qtySpan = line && line.querySelector('.cart-qty-value');
    var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 0;
    var newQty = current;
    if (action === 'increase') newQty = current + 1;
    else if (action === 'decrease') newQty = Math.max(0, current - 1);
    else if (action === 'remove') newQty = 0;
    updateCartLine(key, newQty);
  });

  // Intercept add-to-cart forms to use AJAX
  document.querySelectorAll('form[action="/cart/add"], form#product-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function() { refreshCartDrawer(true); })
        .catch(function() { form.submit(); });
    });
  });
}

function updateCartLine(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function() { refreshCartDrawer(false); });
}

function refreshCartDrawer(openAfter) {
  fetch('/?section_id=', { headers: { 'Accept': 'text/html' } });
  fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = doc.getElementById('cartDrawer');
      var newBadge = doc.getElementById('cartBadge');
      if (newDrawer) document.getElementById('cartDrawer').innerHTML = newDrawer.innerHTML;
      if (newBadge) {
        var oldBadge = document.getElementById('cartBadge');
        if (oldBadge) oldBadge.textContent = newBadge.textContent;
      }
      if (openAfter) {
        document.getElementById('cartDrawer').classList.add('open');
        document.getElementById('cartDrawerOverlay').classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
}

/* ── Sticky Add to Cart (mobile) ───────────────── */
function initStickyAddToCart() {
  var form = document.getElementById('product-form');
  if (!form) return;
  var btn = form.querySelector('#addToCartBtn');
  if (!btn) return;
  if (document.getElementById('stickyAddToCart')) return;

  var bar = document.createElement('div');
  bar.id = 'stickyAddToCart';
  bar.className = 'sticky-atc';
  bar.innerHTML = '<button type="button" class="cta-btn" id="stickyAtcBtn">' + (btn.textContent.trim()) + '</button>';
  document.body.appendChild(bar);

  document.getElementById('stickyAtcBtn').addEventListener('click', function() {
    btn.click();
  });

  var hide = function() {
    var rect = btn.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  };
  window.addEventListener('scroll', hide, { passive: true });
  hide();
}

/* ── Image Zoom on Product Page ────────────────── */
function initImageZoom() {
  var mainImg = document.getElementById('mainImage');
  if (!mainImg) return;

  mainImg.style.cursor = 'zoom-in';
  mainImg.addEventListener('click', function() {
    var overlay = document.createElement('div');
    overlay.className = 'img-zoom-overlay';
    overlay.innerHTML = '<button class="img-zoom-close" aria-label="Stäng">&times;</button><img src="' + mainImg.src.replace(/_800x|x800/g, '_2000x') + '" alt="">';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function() { overlay.classList.add('open'); });

    var close = function() {
      overlay.classList.remove('open');
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        document.body.style.overflow = '';
      }, 250);
    };
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    });
  });

  // Hover zoom on desktop
  if (window.matchMedia('(hover: hover)').matches) {
    var wrap = mainImg.parentElement;
    mainImg.addEventListener('mousemove', function(e) {
      var rect = wrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
      mainImg.style.transform = 'scale(1.5)';
    });
    mainImg.addEventListener('mouseleave', function() {
      mainImg.style.transform = '';
    });
  }
}

/* ── Transparent header scroll detection ───────── */
function initTransparentHeader() {
  var header = document.querySelector('.site-header--transparent');
  if (!header) return;
  var onScroll = function() {
    if (window.scrollY > 50) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ── Recently Viewed (localStorage) ────────────── */
function initRecentlyViewed() {
  // Track current product if on product page
  var prodId = document.body.dataset.productId;
  if (prodId) {
    var viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    viewed = viewed.filter(function(id) { return id !== prodId; });
    viewed.unshift(prodId);
    viewed = viewed.slice(0, 12);
    localStorage.setItem('recentlyViewed', JSON.stringify(viewed));
  }

  // Render any recently-viewed sections on this page
  document.querySelectorAll('[data-recently-viewed]').forEach(function(el) {
    var ids = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    var currentId = el.dataset.excludeId;
    ids = ids.filter(function(id) { return id !== currentId; });
    if (ids.length === 0) {
      el.style.display = 'none';
      return;
    }
    el.style.display = '';
    var limit = parseInt(el.dataset.limit || '8', 10);
    var track = el.querySelector('[data-recently-viewed-track]');
    if (!track) return;
    // Show only cards matching the IDs (rendered in DOM as hidden)
    Array.from(track.children).forEach(function(card) {
      var cardId = card.dataset.productId;
      if (ids.includes(cardId) && ids.indexOf(cardId) < limit) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
}
